import React from 'react';
import { useTranslation } from "react-i18next";

const InfoPanel = (props) => {

  const [t] = useTranslation('common');

    return (
      <React.Fragment>
        <div className="info-panel" style={{ visibility: props.vehicle ? 'visible' : 'hidden' }}>
          <div className="card border-dark mb-3" style={{ maxWidth: "18rem" }}>
            <div className="card-header">{props.agency ? props.agency.toUpperCase() : t("map.infopanel.loadingsimple")}</div>
            <div className="card-body text-dark">
              <h5 className="card-title">{props.vehicle ? t("map.infopanel.vehicle") + props.vehicle.id : t("map.infopanel.loadingsimple")}</h5>
              <p className="card-text pt-2">{props.vehicle ? t("map.infopanel.route") + props.vehicle.properties.route_id : t("map.infopanel.loadingsimple")}</p>
              <p className="card-text">{props.vehicle ? props.vehicle.properties.trip_id ? t("map.infopanel.trip") + props.vehicle.properties.trip_id : 'Départ : N-D' : t("map.infopanel.loadingsimple")}</p>
              <p className="card-text">{props.vehicle ? t("map.infopanel.speed") + parseFloat(props.vehicle.properties.speed).toFixed(2) + ' km/h' : t("map.infopanel.loadingsimple")}</p>
              {props.vehicle ? props.vehicle.properties.bearing?<p className="card-text">{t("map.infopanel.bearing")} <i className="fa fa-arrow-up"
                style={{ transform: `rotate(${props.vehicle.properties.bearing}deg)` }} aria-hidden="true"></i></p> : <p>Direction : ND</p>:t("map.infopanel.loadingsimple")}
            </div>
          </div>
        </div>
      </React.Fragment >
    );

}

export default InfoPanel;